<template>
  <div class="top-bg home-nav-box">
     <div class="home-subtitle"><span>{{$t('T_TOP_TITLE_EPSON')}}</span> <br/>{{$t('T_TOP_TITLE')}}</div>
     <div class="top-item">
       <ul>
         <li @click="changeRouter('home', 'basic')">
           <span>{{$t('T_SIMPLE_MODE')}}</span>
         </li>
         <li @click="changeRouter('home', 'advance')">
           <span>{{$t('T_ADVANCED_MODE')}}</span>
         </li>
       </ul>
     </div>
     <div class="home-note"><span class="fr version">{{version}}</span><span class="fl" @click="changeRouter('notes')">{{$t('T_DISCLAIMER_TITLE')}} >></span></div>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
export default {
  data () {
    return {
      version: 'v2.3.5.20240320'
    }
  },

  components: {},

  computed: {
    ...mapState(['isSimple', 'languageChecked', 'isFirstEnter'])
  },

  methods: {
    ...mapMutations(['SET_ISSIMPLE', 'LANGUAGE', 'SET_UNIT', 'SET_ISFIRSTENTER']),
    changeRouter (router, name) {
      if (name === 'advance') {
        this.SET_ISSIMPLE(false)
      } else {
        this.SET_ISSIMPLE(true)
      }
      this.$router.push({ path: '/' + router })
    }
  },
  mounted () {
    // 根据initConfig 初始化配置
    if (this.isFirstEnter) {
      let unit = this.InitConfig.initUnit
      this.SET_UNIT(unit)
      this.SET_ISFIRSTENTER(false)

      let lang = this.InitConfig.initLanguage
      this.LANGUAGE(lang)
      this.$i18n.locale = lang
    }
  }
}

</script>
<style scoped>
.top-item li:first-child {
  background: #fff url('../assets/parts/basic_mode.png') no-repeat;
  background-size: cover;
}

.top-item li:last-child {
  background: #fff url('../assets/parts/advanced_mode.png') no-repeat;
  background-size: cover;
}

.top-item li {
  width: 340px;
  height: 160px;
  margin: 20px auto 0 auto;
  text-align: left;
  background: #fff;
  background-size: contain;
  border-radius: 10px;
  padding: 20px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  position: relative;
  color: #fff;
  font-size: 30px;
}

</style>
